// File for logic corresponding to footer component
import './footer.scss';



// WEBPACK FOOTER //
// ./client/src/components/footer/index.js